import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";

const HexCard = ({ s }) => (
  <div className="w-[160px] h-[88px] sm:w-[220px] sm:h-[121px] relative group transition-all duration-500 hover:-translate-y-3">
    
    {/* Glow */}
    <div className="absolute -top-1/2 left-0 w-full h-[200%] opacity-0 group-hover:opacity-40 transition bg-cyan-400 blur-xl [clip-path:polygon(50%_0%,100%_25%,100%_75%,50%_100%,0%_75%,0%_25%)]" />

    {/* Body with border wrapper: outer layer creates the border using padding, inner layer is the face */}
    <div className="absolute -top-1/2 left-0 w-full h-[200%] p-[2px] transition group-hover:opacity-100
      [clip-path:polygon(50%_0%,100%_25%,100%_75%,50%_100%,0%_75%,0%_25%)]"
      style={{ background: 'linear-gradient(135deg,#9ca3af,#6b7280)' }}
    >
      <div className="w-full h-full bg-gradient-to-br from-cyan-600 to-blue-700 group-hover:from-orange-500 group-hover:to-red-600 transition
        [clip-path:polygon(50%_0%,100%_25%,100%_75%,50%_100%,0%_75%,0%_25%)]" />
    </div>

    {/* Content */}
    <Link to={s.path} className="relative z-10 flex flex-col justify-center h-full text-white text-center px-4">
      <div className="font-bold">{s.title}</div>
      <div className="text-xs opacity-70">{s.desc}</div>
    </Link>
  </div>
);

// ✅ responsive column detection
const useCols = () => {
  const [cols, setCols] = useState(4);

  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (w > 1200) setCols(5);
      else if (w > 800) setCols(4);
      else if (w > 600) setCols(3);
      else  setCols(2);
    };

    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return cols;
};

// ✅ build rows dynamically
const buildRows = (items, cols) => {
  const rows = [];
  let i = 0;
  let full = true;

  while (i < items.length) {
    const count = full ? cols : Math.max(cols - 1, 1);
    rows.push(items.slice(i, i + count));
    i += count;
    full = !full;
  }

  return rows;
};

const ExploreSection = ({ sections = [], t }) => {
  const { colors } = useTheme();
  const cols = useCols();
  // Remove sentinel/fake items (key === -1) so they don't affect layout counts
  const cleanSections = (sections || []).filter((s) => !(s && s.key === -1));
  const rows = buildRows(cleanSections, cols);

  return (
    <section className="my-10">
      <h2 className={`text-2xl lg:text-3xl font-bold  mb-15 text-center ${colors.text.primary}`}>
        {t ? t("explore.title") : "Explore"}
      </h2>

      <div className="flex flex-col items-center mt-10 md:mt-20">
        {rows.map((row, i) => {
          const desiredCount = i % 2 === 0 ? cols : Math.max(cols - 1, 1);
          const placeholders = Math.max(0, desiredCount - row.length);

          return (
            <div
              key={i}
              className={`flex justify-center my-6 md:my-8 lg:my-9`}
            >
              {row.map((s, idx) => (
                <div key={idx} className="mx-0.5 lg:mx-1.5">
                  <HexCard s={s} />
                </div>
              ))}

              {/* Fill short rows with invisible placeholders so layout stays consistent */}
              {Array.from({ length: placeholders }).map((_, pIdx) => (
                <div key={`ph-${i}-${pIdx}`} className="mx-1" aria-hidden>
                  <div className="w-[160px] h-[88px] sm:w-[220px] sm:h-[121px]" />
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ExploreSection;